import styled from 'styled-components';

export const Container = styled.div`
  background: #3a3a3a;
  border: 1px solid #454545;
  border-radius: 77px;
  padding: 5px 25px;

  input {
    width: calc(100% - 33px);
    border: none;
    background: transparent;
  }
`;
